import React from 'react';
import { Modal } from 'react-bootstrap';
import { HiXMark, HiExclamationTriangle } from 'react-icons/hi2';
import './LossConfirm.scss';

interface LossConfirmProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  systemStock: number;
  newRealStock: number;
  acronym?: string;
}

const LossConfirm: React.FC<LossConfirmProps> = ({ show, onClose, onConfirm, systemStock, newRealStock, acronym }) => {
  const loss = Math.max(0, systemStock - newRealStock);
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="mp-modal">
      <Modal.Header className="mp-modal-header">
        <div className="form-modal-title-container">
          <span className="form-modal-title">Confirmar Pérdida</span>
        </div>
        <button className="mp-modal-close" onClick={onClose}>
          <HiXMark size={20} />
        </button>
      </Modal.Header>
      <Modal.Body className="loss-confirm-body">
        <div className="loss-card">
          <div className="icon"><HiExclamationTriangle size={18} /></div>
          <div className="text">
            <div className="title">Se registrará una pérdida</div>
            <div className="subtitle">Cantidad: {loss} {acronym ?? ''}</div>
          </div>
        </div>
        <div className="note">Estás actualizando el stock real a un valor menor que el stock en sistema. ¿Deseas continuar?</div>
      </Modal.Body>
      <Modal.Footer className="mp-modal-footer">
        <button className="mp-modal-btn-cancel" onClick={onClose}>Cancelar</button>
        <button className="mp-modal-btn-submit" onClick={onConfirm}>Confirmar</button>
      </Modal.Footer>
    </Modal>
  );
};

export default LossConfirm;
